import { UserPen } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/utils/cn'
import { formatDateTimeLocalized } from '@/utils/date'

/** The provenance stamp hand-made nodes and edges carry (services/manual_graph). */
const MANUAL_ORIGIN = 'manual'

function stamp(properties: Record<string, unknown>, key: string): string | undefined {
  const value = properties[key]
  return typeof value === 'string' && value.trim() ? value : undefined
}

/**
 * "Created manually by Jana Nováková on 18 Oct 2026, 11:42" — for an entity or
 * a relationship an analyst added by hand. Renders nothing for extracted data.
 */
export function ManualProvenance({
  properties,
  className,
}: {
  properties: Record<string, unknown> | undefined
  className?: string
}) {
  const { t, i18n } = useTranslation()
  if (properties?._origin !== MANUAL_ORIGIN) return null
  const name = stamp(properties, '_created_by_name')
  const at = stamp(properties, '_created_at')
  // The shared formatter keeps the Gregorian calendar in every language (Thai included).
  const date =
    at && !Number.isNaN(Date.parse(at)) ? formatDateTimeLocalized(at, i18n.language) : undefined
  const text = name
    ? date
      ? t('manualGraph.provenance.byOn', { name, date })
      : t('manualGraph.provenance.by', { name })
    : t('manualGraph.provenance.manual')
  return (
    <p className={cn('flex items-center gap-1.5 text-xs text-muted-foreground', className)}>
      <UserPen className="size-3.5 shrink-0" aria-hidden />
      <span className="min-w-0">{text}</span>
    </p>
  )
}
